export default "__VITE_ASSET__DCmlxExI__"